module.exports = __webpack_public_path__ + "static/media/009 I GUERRA M_Industrie ausiliarie.6612ae17.svg";